export default __webpack_public_path__ + "static/media/lock.bc28e3fd.svg";